import React from 'react';

export type UseBoolean = [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
  {
    setFalse: () => void,
    setTrue: () => void,
    toggle: () => void,
  },
];

export default function useBoolean(defaultValue: boolean): UseBoolean {
  const [value, setValue] = React.useState(defaultValue);

  function setFalse() {
    setValue(false);
  }

  function setTrue() {
    setValue(true);
  }

  function toggle() {
    setValue((v: boolean) => (!v));
  }

  const opts = {
    setFalse,
    setTrue,
    toggle,
  };

  return [value, setValue, opts];
}
